import React from "react";
import { create } from "zustand";
import DataListStore from "store/DataListStore";
import ListViewV2 from "../DataListV2";

const watchListTiktokStore = create(DataListStore);
const watchListTiktokDetailStore = create(DataListStore);

export default function WatchListTiktok() {
  return (
    <>
      <ListViewV2 viewId="wltiktok" store={watchListTiktokStore} />

      <ListViewV2 viewId="wltiktokdetail" store={watchListTiktokDetailStore} />
    </>
  );
}
